module.exports = __webpack_public_path__ + "static/jean-marie-jobs-e42ea42b6e972c5d0a6221f78d916bc8.png";